import React from "react";
import { BarChart3Icon, BellIcon, CheckCircle2Icon, ChevronDownIcon, CreditCardIcon, FileTextIcon, FolderIcon, HomeIcon, LayoutGridIcon, MapPinIcon, MessageSquareIcon, MoreHorizontalIcon, RecycleIcon, SearchIcon, ShieldCheckIcon, UserIcon, WalletIcon, BoxIcon } from "lucide-react";
import { TRUST_HERO_CITY, trustDashboard as d, trustPhone as p, Bi } from "../../data/trustHero";
type Pick = (b: Bi) => string;

/* Same logo files as the global site header */
const BCITI_LOGO = 'https://cdn.magicpatterns.com/uploads/kFQruRR3oauw7NNUdgFajn/Logo_BCITI_(5).png';
const ATNA_LOGO = 'https://cdn.magicpatterns.com/uploads/d6cqpG2SGUofNqC1hEedXv/Logo_ATNA_(5).png';
const NAV_ICONS: BoxIcon[] = [HomeIcon, LayoutGridIcon, FileTextIcon, FileTextIcon, WalletIcon, MessageSquareIcon, FolderIcon, BarChart3Icon];
const TILE_ICONS: Record<(typeof p.tiles)[number]['key'], BoxIcon> = {
  requests: FileTextIcon,
  permits: FileTextIcon,
  payments: CreditCardIcon,
  collect: RecycleIcon,
  comms: MessageSquareIcon,
  more: MoreHorizontalIcon
};
const TAB_ICONS: BoxIcon[] = [HomeIcon, LayoutGridIcon, BellIcon, UserIcon];
const QR = ['1110111', '1010101', '1110111', '0001000', '1101011', '0110110', '1011101'];
function QrBlock({
  size = 3
}: {
  size?: number;
}) {
  return <div className="bg-white p-[3px] rounded-[3px]" aria-hidden="true" data-id="element-6874" data-mp="le3tq6juno4v">
      {QR.map((row, i) => <div key={i} className="flex" data-id="element-6875" data-mp="q8hktwrhb93q" data-mpi={i}>
          {row.split('').map((c, j) => <span key={j} style={{
        width: size,
        height: size
      }} className={c === '1' ? 'bg-[#121A3A]' : 'bg-white'} data-id="element-6876" data-mp="v9fcczydpfhw" data-mpi={j} />)}
        </div>)}
    </div>;
}
export function TrustLaptop({
  pick,
  lang
}: {
  pick: Pick;
  lang: 'FR' | 'EN';
}) {
  const months = lang === 'FR' ? d.months.fr : d.months.en;
  // data-note: {d.demoNote}
  return <div className="w-[470px]" data-id="element-6877" data-mp="1e0omnbfz48aj">
      <div className="rounded-t-[16px] bg-[#1B1F2E] p-[7px] pb-[9px] shadow-[0_34px_60px_-30px_rgba(18,26,58,0.55)]" data-id="element-6878" data-mp="1e1hkto0v9ph2">
        <div className="rounded-[9px] bg-white overflow-hidden h-[282px] flex flex-col" data-id="element-6879" data-mp="1j016rofgn19f">
          <div className="h-[34px] shrink-0 border-b border-[#EEEDF6] flex items-center justify-between pl-2 pr-3" data-id="element-6880" data-mp="tc5masx84i87">
            <div className="flex items-center" data-id="element-6881" data-mp="oe40w1cbs6tk">
              <img src={BCITI_LOGO} alt="BCITI" className="h-[30px] w-auto object-contain" data-id="element-6882" data-mp="131p5y0srgg44" />
              <span className="mx-1 h-3.5 w-px bg-[#D9DBE3]" aria-hidden="true" data-id="element-6883" data-mp="yaqj0id9ojrw" />
              <img src={ATNA_LOGO} alt="ATNA" className="h-[26px] w-auto object-contain" data-id="element-6884" data-mp="1c1vf5ahfetxh" />
            </div>
            <div className="flex items-center gap-2" data-id="element-6885" data-mp="1730xibv73bey">
              <span className="flex items-center gap-1 rounded-md border border-[#E7E8EF] px-1.5 py-[3px] font-sans text-[7.5px] text-[#121A3A]" data-id="element-6886" data-mp="1728z6ta7qzkz">
                <MapPinIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-6887" data-mp="1h1817t0h3wz0" />
                {d.city}
                <ChevronDownIcon className="w-2.5 h-2.5 text-[#8A8FA6]" aria-hidden="true" data-id="element-6888" data-mp="3nr4pcapnh2jq" />
              </span>
              <span className="w-4 h-4 rounded-full border border-[#D9DBE3] flex items-center justify-center" data-id="element-6889" data-mp="3isuy2b71qm3e">
                <UserIcon className="w-2.5 h-2.5 text-[#4A5268]" aria-hidden="true" data-id="element-6890" data-mp="1ybbx8rq50xa1" />
              </span>
            </div>
          </div>
          <div className="flex flex-1 min-h-0" data-id="element-6891" data-mp="23bgfam6p202d">
            <aside className="w-[96px] shrink-0 border-r border-[#EEEDF6] bg-[#FBFBFE] px-1.5 py-2.5" data-id="element-6892" data-mp="1ol96ky6hnvev">
              <ul className="space-y-[3px]" data-id="element-6893" data-mp="1tisihrfprw3n">
                {d.nav.map((n, i) => {
                const Icon = NAV_ICONS[i];
                return <li key={n.fr} className={`flex items-center gap-1.5 rounded px-1.5 py-[4px] font-sans text-[6.5px] ${i === 0 ? 'bg-[#EDEBFD] text-[#4F46E5] font-semibold' : 'text-[#5A6178]'}`} data-id="element-6894" data-mp="1fihr8nahsfhy" data-mpi={i}>
                      <Icon className="w-2.5 h-2.5 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-6895" data-mp="15ng3nvvv7lhh" />
                      <span className="truncate" data-id="element-6896" data-mp="1akyexsxcucsn">{pick(n)}</span>
                    </li>;
              })}
              </ul>
            </aside>
            <div className="flex-1 min-w-0 p-3" data-id="element-6897" data-mp="34yh86qkcr985">
              <p className="font-sans text-[11px] font-semibold text-[#121A3A]" data-id="element-6898" data-mp="34y7h0znkmw0v">{pick(d.title)}</p>
              <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-6899" data-mp="14vy699stapgv">
                <div className="rounded-lg border border-[#EEEDF6] p-2" data-id="element-6900" data-mp="zwvcwmm727oq">
                  <p className="flex items-center gap-1 font-sans text-[7px] font-semibold text-[#121A3A]" data-id="element-6901" data-mp="vvruptgobzkc">
                    <CheckCircle2Icon className="w-2.5 h-2.5 text-[#22A06B]" aria-hidden="true" data-id="element-6902" data-mp="qwys4w2xdsyy" />
                    {pick(d.recommendations.label)}
                  </p>
                  <p className="mt-1.5 flex items-baseline gap-1.5" data-id="element-6903" data-mp="lzotcptnc4yg">
                    <span className="font-sans text-[17px] font-semibold text-[#121A3A] leading-none" data-id="element-6904" data-mp="h63ukvk8b6y7">{pick(d.recommendations.value)}</span>
                    <span className="rounded bg-[#E8F6EF] px-1 py-[1px] font-sans text-[6px] font-semibold text-[#1C8A5B]" data-id="element-6905" data-mp="c5g2s7o6em2x">{pick(d.recommendations.delta)}</span>
                  </p>
                  <p className="mt-1 font-sans text-[6px] text-[#9AA0B4]" data-id="element-6906" data-mp="36cn7do7wot6">{pick(d.recommendations.period)}</p>
                </div>
                <div className="rounded-lg border border-[#EEEDF6] p-2" data-id="element-6907" data-mp="29vmy3rzqahil">
                  <p className="font-sans text-[7px] font-semibold text-[#121A3A]" data-id="element-6908" data-mp="29xh6y7xq6j6b">{pick(d.confidence.label)}</p>
                  <div className="mt-1 flex items-center gap-2.5" data-id="element-6909" data-mp="2ewakg0d0ia6h">
                    <svg viewBox="0 0 36 36" className="w-9 h-9" aria-hidden="true" data-id="element-6910" data-mp="2ju2h17olqkh0">
                      <circle cx="18" cy="18" r="14" fill="none" stroke="#EEF0F4" strokeWidth="3.5" data-id="element-6911" data-mp="2nturxr1gx2pj" />
                      <circle cx="18" cy="18" r="14" fill="none" stroke="#22A06B" strokeWidth="3.5" strokeLinecap="round" strokeDasharray={`${0.82 * 88} 88`} transform="rotate(-90 18 18)" data-id="element-6912" data-mp="1r66n2aqf36nx" />
                      <text x="18" y="20.5" textAnchor="middle" className="font-sans" fontSize="7.5" fontWeight="600" fill="#121A3A" data-id="element-6913" data-mp="204igslmkykkl">
                        {pick(d.confidence.value)}
                      </text>
                    </svg>
                    <span className="flex flex-col items-center gap-0.5" data-id="element-6914" data-mp="18cb05l72r867">
                      <ShieldCheckIcon className="w-3 h-3 text-[#22A06B]" aria-hidden="true" data-id="element-6915" data-mp="1cefvcod68cuy" />
                      <span className="font-sans text-[6px] text-[#5A6178]" data-id="element-6916" data-mp="2fpbscoibt6um">{pick(d.confidence.level)}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-6917" data-mp="2pg6frw7b6chn">
                <div className="rounded-lg border border-[#EEEDF6] p-2" data-id="element-6918" data-mp="2kh39y9ji828m">
                  <p className="font-sans text-[7px] font-semibold text-[#121A3A]" data-id="element-6919" data-mp="2kjz9g2b02yz6">{pick(d.activity)}</p>
                  <svg viewBox="0 0 120 52" className="mt-1 w-full h-[62px]" aria-hidden="true" data-id="element-6920" data-mp="1rsxotlojgb89">
                    {[8, 20, 32, 44].map(y => <line key={y} x1="0" x2="120" y1={y} y2={y} stroke="#F0F0F6" strokeWidth="0.6" data-id="element-6921" data-mp="25t8isxl5a5xn" />)}
                    <polygon points="2,44 18,38 32,40 48,33 62,35 78,26 92,28 106,15 118,8 118,48 2,48" fill="#EEEDFD" data-id="element-6922" data-mp="21qvmezsafkdj" />
                    <polyline points="2,44 18,38 32,40 48,33 62,35 78,26 92,28 106,15 118,8" fill="none" stroke="#4F46E5" strokeWidth="1.5" strokeLinejoin="round" data-id="element-6923" data-mp="3h6km97czsmja" />
                  </svg>
                  <div className="flex justify-between font-sans text-[5px] text-[#9AA0B4]" data-id="element-6924" data-mp="3korvmhjrc55b">
                    {months.map(m => <span key={m} data-id="element-6925" data-mp="3ppnxkpkjth83">{m}</span>)}
                  </div>
                </div>
                <div className="rounded-lg border border-[#EEEDF6] p-2" data-id="element-6926" data-mp="3asounf0n6cjy">
                  <p className="font-sans text-[7px] font-semibold text-[#121A3A]" data-id="element-6927" data-mp="3fq6u8esrrffa">{pick(d.sourcesTitle)}</p>
                  <ul className="mt-2 space-y-[7px]" data-id="element-6928" data-mp="7an4vqv7yh5i">
                    {d.sources.map(s => <li key={s.label.fr} className="flex items-center justify-between gap-1 font-sans text-[6px] text-[#3A4260]" data-id="element-6929" data-mp="ca00p142iyk8">
                        <span className="flex items-center gap-1 min-w-0" data-id="element-6930" data-mp="3tpgb7gosudkb">
                          <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{
                        backgroundColor: s.color
                      }} aria-hidden="true" data-id="element-6931" data-mp="2jwxk838g486" />
                          <span className="truncate" data-id="element-6932" data-mp="v0hgk53sxzo6">{pick(s.label)}</span>
                        </span>
                        <span className="tabular-nums whitespace-nowrap" data-id="element-6933" data-mp="2r3m7ljn02dxo">{pick(s.value)}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-[-22px] h-[11px] rounded-b-[12px] bg-[#D6D8E0]" aria-hidden="true" data-id="element-6934" data-mp="2icdiz0qqydce" />
    </div>;
}
export function TrustPhone({
  pick
}: {
  pick: Pick;
}) {
  return <div className="w-[178px] rounded-[28px] bg-[#1B1F2E] p-[6px] shadow-[0_30px_60px_-24px_rgba(18,26,58,0.5)]" data-id="element-6935" data-mp="3a28cl9ln0p6v">
      <div className="rounded-[23px] bg-white overflow-hidden" data-id="element-6936" data-mp="360n21uwksmzu">
        <div className="flex justify-center pt-2" aria-hidden="true" data-id="element-6937" data-mp="311tlftlzsfvg">
          <span className="w-14 h-3.5 rounded-full bg-[#1B1F2E]" data-id="element-6938" data-mp="30zz0ifaq0nrd" />
        </div>
        <div className="px-3 pt-2 flex items-center justify-between" data-id="element-6939" data-mp="2w1xilxp16uhh">
          <span className="flex items-center gap-1 font-sans text-[9px] font-semibold text-[#121A3A]" data-id="element-6940" data-mp="1pn6cnfl1wjgl">
            <ShieldCheckIcon className="w-3 h-3 text-[#4F46E5]" aria-hidden="true" data-id="element-6941" data-mp="1knahm5uc02d6" />
            {p.city}
          </span>
          <SearchIcon className="w-3 h-3 text-[#4A5268]" aria-hidden="true" data-id="element-6942" data-mp="1aky3bnra386h" />
        </div>
        <div className="relative mx-3 mt-2.5 rounded-xl overflow-hidden h-[74px]" data-id="element-6943" data-mp="1fjrj5mu1fb9t">
          <img src={TRUST_HERO_CITY} alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-6944" data-mp="1khjaaemuytcy" />
          <div className="absolute inset-0 bg-[#2B2F8F]/60" aria-hidden="true" data-id="element-6945" data-mp="1p8rix8gd6ap2" />
          <div className="relative p-2 flex justify-between items-start text-white" data-id="element-6946" data-mp="1tad2tdrbfp8r">
            <div data-id="element-6947" data-mp="1y97m0gt73fte">
              <p className="font-sans text-[8px] font-semibold" data-id="element-6948" data-mp="1y8odtrtck5sk">{pick(p.card)}</p>
              <p className="mt-1.5 font-sans text-[7px]" data-id="element-6949" data-mp="238apvxxfvfzs">{p.name}</p>
              <p className="font-sans text-[6.5px] text-white/80" data-id="element-6950" data-mp="2392a6cll5rar">{pick(p.role)}</p>
            </div>
            <QrBlock size={2.6} data-id="element-6951" data-mp="286lyy6fwtmgy" />
          </div>
        </div>
        <p className="px-3 mt-3 font-sans text-[8.5px] font-semibold text-[#121A3A]" data-id="element-6952" data-mp="8vb6rutuo3nr">{pick(p.services)}</p>
        <div className="px-3 mt-2 grid grid-cols-3 gap-y-2.5" data-id="element-6953" data-mp="due38qvrl1k4">
          {p.tiles.map(t => {
          const Icon = TILE_ICONS[t.key];
          return <div key={t.key} className="flex flex-col items-center gap-1" data-id="element-6954" data-mp="20gw4aaycqslk">
                <Icon className="w-3.5 h-3.5 text-[#4F46E5]" strokeWidth={1.8} aria-hidden="true" data-id="element-6955" data-mp="25dwcosioc7fu" />
                <span className="font-sans text-[5.5px] text-[#3A4260] text-center leading-tight" data-id="element-6956" data-mp="29dwo04ah82io">{pick(t.label)}</span>
              </div>;
        })}
        </div>
        <div className="mt-4 border-t border-[#EEEDF6] px-2 py-2 flex justify-around" data-id="element-6957" data-mp="2je71zr4c5dyw">
          {p.tabs.map((tab, i) => {
          const Icon = TAB_ICONS[i];
          return <span key={tab.fr} className={`flex flex-col items-center gap-0.5 font-sans text-[5.5px] ${i === 0 ? 'text-[#4F46E5]' : 'text-[#8A8FA6]'}`} data-id="element-6958" data-mp="2t372xg2eejfq" data-mpi={i}>
                <Icon className="w-3 h-3" strokeWidth={2} aria-hidden="true" data-id="element-6959" data-mp="2x4ajk4s9sji0" />
                {pick(tab)}
              </span>;
        })}
        </div>
      </div>
    </div>;
}